// pages/Testimonials.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaStar, FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Testimonials.css';
import testi1 from '../../assets/images/team/testi-1.webp';
import testi2 from '../../assets/images/team/testi-2.webp';
import testi3 from '../../assets/images/team/testi-3.webp';
import testi4 from '../../assets/images/team/testi-4.webp';
import testi5 from '../../assets/images/team/testi-5.webp';
import testi6 from '../../assets/images/team/testi-6.webp';

const testimonials = [
    {
        id: 1,
        name: 'Sarah Johnson',
        position: 'CEO, TechInnovate Inc.',
        company: 'Tech Company',
        rating: 5,
        testimonial: 'GForce Solutions delivered our e-commerce platform 2 weeks ahead of schedule. Their attention to detail and technical expertise exceeded our expectations. Revenue increased by 45% in the first quarter!',
        project: 'E-commerce Platform',
        budget: '$25,000',
        timeline: '8 weeks',
        image: testi1
    },
    {
        id: 2,
        name: 'Michael Rodriguez',
        position: 'Marketing Director',
        company: 'Global Retail Co.',
        rating: 5,
        testimonial: 'The responsive website they built for us performs flawlessly on all devices. Our bounce rate decreased by 60% and mobile conversions increased by 35%. Their team is professional and responsive.',
        project: 'Corporate Website Redesign',
        budget: '$12,500',
        timeline: '6 weeks',
        image: testi2
    },
    {
        id: 3,
        name: 'Jennifer Lee',
        position: 'Founder & CEO',
        company: 'Startup XYZ',
        rating: 5,
        testimonial: 'As a startup with limited technical knowledge, GForce guided us through every step. Our React application is scalable, fast, and has helped us secure Series A funding. Highly recommended!',
        project: 'SaaS Platform',
        budget: '$45,000',
        timeline: '12 weeks',
        image: testi3
    },
    {
        id: 4,
        name: 'Robert Chen',
        position: 'Operations Manager',
        company: 'Manufacturing Corp',
        rating: 5,
        testimonial: 'The inventory management system they developed has streamlined our operations completely. Real-time tracking and reporting features have saved us 20 hours per week in manual work.',
        project: 'Custom Web Application',
        budget: '$32,000',
        timeline: '10 weeks',
        image: testi4
    },
    {
        id: 5,
        name: 'Amanda Wilson',
        position: 'Director of Digital',
        company: 'Healthcare Network',
        rating: 5,
        testimonial: 'Patient portal development with HIPAA compliance was handled flawlessly. The team demonstrated exceptional knowledge of security protocols and healthcare regulations.',
        project: 'Healthcare Portal',
        budget: '$68,000',
        timeline: '16 weeks',
        image: testi5
    },
    {
        id: 6,
        name: 'David Park',
        position: 'E-commerce Manager',
        company: 'Fashion Retail',
        rating: 5,
        testimonial: 'Our online store conversion rate increased by 180% after the redesign. The checkout process optimization alone increased sales by 40%. Outstanding results!',
        project: 'E-commerce Redesign',
        budget: '$28,500',
        timeline: '9 weeks',
        image: testi6
    }
];

const metrics = [
    { value: '98%', label: 'Client Satisfaction' },
    { value: '250+', label: 'Projects Delivered' },
    { value: '95%', label: 'On-time Delivery' },
    { value: '50+', label: 'Happy Clients' },
    { value: '24/7', label: 'Support Available' }
];

const Testimonials = () => {
  const navigate = useNavigate();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedFilter] = useState('all');

    const filteredTestimonials = selectedFilter === 'all'
        ? testimonials
        : testimonials.filter(t =>
            selectedFilter === 'ecommerce' ? t.project.toLowerCase().includes('e-commerce') :
                selectedFilter === 'saas' ? t.project.toLowerCase().includes('saas') || t.project.toLowerCase().includes('platform') :
                    selectedFilter === 'corporate' ? t.project.toLowerCase().includes('corporate') || t.project.toLowerCase().includes('website') :
                        testimonials
        );

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === filteredTestimonials.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? filteredTestimonials.length - 1 : prevIndex - 1
        );
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    const renderStars = (rating) => {
        return Array.from({ length: 5 }, (_, i) => (
            <FaStar
                key={i}
                className={i < rating ? 'star filled' : 'star'}
            />
        ));
    };

    return (
        <section id="testimonials" className="section testimonials">
            <div className="animated-bg">
                <div className="bg-grid"></div>
            </div>
            
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">What Our Clients Say</h2>
                    <p className="section-subtitle">
                        Trusted by businesses worldwide for delivering exceptional web solutions
                    </p>
                </div>

                {/* Metrics Section */}
                <div className="metrics-grid">
                    {metrics.map((metric, index) => (
                        <div key={index} className="metric-card card">
                            <div className="metric-value">{metric.value}</div>
                            <div className="metric-label">{metric.label}</div>
                        </div>
                    ))}
                </div>

                {/* Testimonial Filters */}
                {/* <div className="testimonial-filters">
                    <button
                        className={`filter-btn ${selectedFilter === 'all' ? 'active' : ''}`}
                        onClick={() => setSelectedFilter('all')}
                    >
                        All Projects
                    </button>
                    <button
                        className={`filter-btn ${selectedFilter === 'ecommerce' ? 'active' : ''}`}
                        onClick={() => setSelectedFilter('ecommerce')}
                    >
                        E-commerce
                    </button>
                    <button
                        className={`filter-btn ${selectedFilter === 'saas' ? 'active' : ''}`}
                        onClick={() => setSelectedFilter('saas')}
                    >
                        SaaS Platforms
                    </button>
                    <button
                        className={`filter-btn ${selectedFilter === 'corporate' ? 'active' : ''}`}
                        onClick={() => setSelectedFilter('corporate')}
                    >
                        Corporate Websites
                    </button>
                </div> */}

                {/* Main Testimonial Carousel */}
                <div className="testimonial-carousel">
                    <div className="carousel-container">
                        <button className="carousel-btn prev" onClick={prevSlide}>
                            <FaChevronLeft />
                        </button>

                        <div className="carousel-slide">
                            <div className="testimonial-main card">
                                <div className="quote-icon">
                                    <FaQuoteLeft />
                                </div>

                                <div className="testimonial-content">
                                    <p className="testimonial-text">
                                        "{filteredTestimonials[currentIndex].testimonial}"
                                    </p>

                                    <div className="testimonial-rating">
                                        {renderStars(filteredTestimonials[currentIndex].rating)}
                                    </div>

                                    <div className="testimonial-author">
                                        <div className="author-image">
                                            <img
                                                src={filteredTestimonials[currentIndex].image}
                                                alt={filteredTestimonials[currentIndex].name}
                                                width="200"
                                                height="200"
                                                loading="lazy"
                                                decoding="async"
                                            />
                                        </div>
                                        <div className="author-info">
                                            <h4>{filteredTestimonials[currentIndex].name}</h4>
                                            <p>{filteredTestimonials[currentIndex].position}</p>
                                            <p className="author-company">{filteredTestimonials[currentIndex].company}</p>
                                        </div>
                                    </div>

                                    <div className="project-details">
                                        <div className="project-detail">
                                            <span className="detail-label">Project:</span>
                                            <span className="detail-value">{filteredTestimonials[currentIndex].project}</span>
                                        </div>
                                        <div className="project-detail">
                                            <span className="detail-label">Budget:</span>
                                            <span className="detail-value">{filteredTestimonials[currentIndex].budget}</span>
                                        </div>
                                        <div className="project-detail">
                                            <span className="detail-label">Timeline:</span>
                                            <span className="detail-value">{filteredTestimonials[currentIndex].timeline}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="carousel-btn next" onClick={nextSlide}>
                            <FaChevronRight />
                        </button>
                    </div>

                    {/* Carousel Dots */}
                    <div className="carousel-dots">
                        {filteredTestimonials.map((_, index) => (
                            <button
                                key={index}
                                className={`dot ${index === currentIndex ? 'active' : ''}`}
                                onClick={() => goToSlide(index)}
                            />
                        ))}
                    </div>
                </div>

                {/* Additional Testimonials Grid */}
                <div className="testimonials-grid">
                    {filteredTestimonials.slice(0, 3).map((testimonial, index) => (
                        <div key={testimonial.id} className="testimonial-card card">
                            <div className="testimonial-header">
                                <div className="author-avatar">
                                    <img src={testimonial.image} alt={testimonial.name} width="200" height="200" loading="lazy" decoding="async" />
                                </div>
                                <div className="author-header">
                                    <h4>{testimonial.name}</h4>
                                    <p>{testimonial.position}</p>
                                    <div className="testimonial-rating-small">
                                        {renderStars(testimonial.rating)}
                                    </div>
                                </div>
                            </div>

                            <div className="testimonial-body">
                                <p className="testimonial-excerpt">
                                    "{testimonial.testimonial.length > 150
                                        ? testimonial.testimonial.substring(0, 150) + '...'
                                        : testimonial.testimonial}"
                                </p>

                                {/* <div className="project-info">
                                    <span className="project-type">{testimonial.project}</span>
                                    <div className="project-meta">
                                        <span className="meta-item">${testimonial.budget.replace('$', '')}</span>
                                        <span className="meta-item">{testimonial.timeline}</span>
                                    </div>
                                </div> */}
                            </div>

                            <div className="testimonial-footer">
                                <button className="read-full-link">Read Full Story →</button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Client Logos */}
                <div className="client-logos">
                    <h3 className="logos-title">Trusted By Industry Leaders</h3>
                    <div className="logos-grid">
                        <div className="logo-item">TECH INNOVATE</div>
                        <div className="logo-item">GLOBAL RETAIL</div>
                        <div className="logo-item">HEALTHCARE NET</div>
                        <div className="logo-item">FASHION CO.</div>
                        <div className="logo-item">STARTUP XYZ</div>
                        <div className="logo-item">MANUFACT CORP</div>
                    </div>
                </div>

                {/* CTA Section */}
                <div className="testimonial-cta card">
                    <div className="cta-content">
                        <h3>Ready to join our satisfied clients?</h3>
                        <p>Start your project with us and experience the GForce Solutions</p>
                    </div>
                    <div className="cta-buttons">
                        <button
                            className="btn"
                            onClick={() => navigate('/contact')}
                        >
                            Start Your Project
                        </button>
                        <button
                            className="btn btn-outline"
                            onClick={() => navigate('/portfolio')}
                        >
                            View Case Studies
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;